import { Instance, types } from 'mobx-state-tree'
import '../../ieConfig/MobxConfig'

export const Subscription = types.model('Subscription', {
  isEnabled: types.optional(types.boolean, false),
  blockFund: types.optional(types.boolean, false),
  consentId: types.optional(types.string, ''),
  frequency: types.optional(types.number, 0),
  revocable: types.optional(types.boolean, false),
  ruleAmount: types.optional(types.string, ''),
  ruleAmountValue: types.optional(types.number, 0),
  ruleRecurrence: types.optional(types.string, ''),
  ruleRecurrenceValue: types.optional(types.number, 0),
  scheduled: types.optional(types.boolean, false),
  scheduledAt: types.optional(types.string, ''),
  scheduledEnd: types.optional(types.string, ''),
  share: types.optional(types.boolean, false),
  type: types.optional(types.number, 0),
  allowPurchase: types.optional(types.boolean, false),
  tenure: types.optional(types.string, '12 Months'),
  payType: types.optional(types.string, ''),
  tenureDate: types.optional(types.string, '5th of every month'),
})

export type SubscriptionType = Instance<typeof Subscription>
